import React, { useState } from 'react';
import { SearchInput, ViewToggle } from '../../shared';
import styles from './CustomerFilterBar.module.css';

export const CustomerFilterBar: React.FC = () => {
  const [view, setView] = useState<'card' | 'grid'>('card');
  const [showFilters, setShowFilters] = useState(false);
  const [activeStatus, setActiveStatus] = useState('All');

  return (
    <div className={styles.wrap}>
      <div className={styles.row}>
        <div className={styles.searchCol}>
          <SearchInput placeholder="Search customers..." />
        </div>
        <div className={styles.actions}>
          <button
            className={`${styles.filterBtn} ${showFilters ? styles.filterBtnActive : ''}`}
            onClick={() => setShowFilters((p) => !p)}
          >
            ⚙ Filter
          </button>
          <ViewToggle value={view} onChange={setView} />
        </div>
      </div>

      {showFilters && (
        <div className={styles.filterPanel}>
          <p className={styles.filterLabel}>Customer Status</p>
          <div className={styles.statusRow}>
            {['All', 'Active', 'Dormant'].map((s) => (
              <button
                key={s}
                className={`${styles.pill} ${activeStatus === s ? styles.pillActive : ''}`}
                onClick={() => setActiveStatus(s)}
              >
                {s}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
